
































import Vue from "vue";
import { mapState, mapActions } from "vuex";
import { TransactionSearchOptions, PageConfig } from "../../types";
import { encodeQueryParams } from "@canvas/api/lib/utils";
import DesignerSearch from "../DesignerSearch.vue";
export default Vue.extend({
  name: "search-projects",
  data() {
    return {
      search: {
        placeholder: "Search",
        buttonText: "Search",
        isDropdownAvailable: true,
        dropdownOptions: TransactionSearchOptions,
        dropdownSelected: {} as { name: string; display_name: string },
        searchText: ""
      },
      searchDesignerData: {
        name: "",
        display_name: ""
      }
    };
  },
  computed: {
    ...mapState("uiModule", {
      modalElement: "modalElement"
    }),
    ...mapState("appModule", {
      selectedEc: "selectedEc",
      breadcrumb: "breadcrumb"
    }),
    customRenderer() {
      if (
        this.search.dropdownSelected.name === TransactionSearchOptions[1].name
      ) {
        return DesignerSearch;
      } else {
        return null;
      }
    }
  },
  provide(): any {
    return {
      updateDesigner: this.handleSearchDesignerAction,
      getDesignerData: this.getDesignerSearchData
    };
  },
  methods: {
    ...mapActions("appModule", ["searchInventoryProducts"]),
    handleSearchClick(searchData: {
      searchText: string;
      option: { name: string; display_name: string };
    }) {
      if (searchData && searchData.option) {
        this.search.searchText = searchData.searchText;
        this.onHistorySearch(searchData);
      }
    },
    handleSearchDesignerAction(value: { name: string; display_name: string }) {
      //update the designer details in searchbar so enable search on that field
      this.searchDesignerData = {
        name: value.name,
        display_name: value.display_name
      };
      this.search.searchText = value.name.toString();
    },
    handleDropdownSelected(value: { name: string; display_name: string }) {
      //clear the searchText when user dropdown is selected and is user search
      if (
        this.search.dropdownSelected.name === TransactionSearchOptions[1].name
      ) {
        this.search.searchText = "";
        this.searchDesignerData = {
          name: "",
          display_name: ""
        };
      }
      this.search.dropdownSelected = value;
    },
    getDesignerSearchData() {
      return this.searchDesignerData;
    },
    onHistorySearch(searchData: {
      searchText: string;
      option: { name: string; display_name: string };
    }) {
      let pageConfig = PageConfig;
      const apiQuery = {
        [searchData.option.name]: searchData.searchText,
        limit: pageConfig.limit,
        offset: pageConfig.offset,
        ec_id__in: this.selectedEc.name
      };
      pageConfig.query = encodeQueryParams(apiQuery);
      const routeLink =
        "/" +
        this.selectedEc.name +
        "/trxnhistory/" +
        JSON.stringify({
          search: searchData,
          designerSearch: this.searchDesignerData,
          pageConfig: pageConfig
        });
      this.$router.push({
        path: routeLink
      });
    },
    handleInitComponent() {
      this.search.searchText = "";
      this.search.dropdownSelected = this.search.dropdownOptions[0];
      this.searchDesignerData = {
        name: "",
        display_name: ""
      };
      this.onHistorySearch({
        searchText: this.search.searchText,
        option: this.search.dropdownSelected
      });
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === "trxnhistory") {
      this.handleInitComponent();
    } else {
      next();
    }
  },
  created() {
    if (!this.$router.currentRoute.params.searchQuery) {
      this.handleInitComponent();
    } else {
      const paramsJSON = JSON.parse(
        this.$router.currentRoute.params.searchQuery
      );
      this.search.searchText = paramsJSON.search.searchText;
      this.search.dropdownSelected = paramsJSON.search.option;
      if (
        this.search.dropdownSelected.name === TransactionSearchOptions[1].name
      ) {
        this.searchDesignerData = paramsJSON.designerSearch;
      }
    }
  }
});
